import { render, staticRenderFns } from "./tuijian.vue?vue&type=template&id=aaef3cb8&scoped=true&"
import script from "./tuijian.vue?vue&type=script&lang=js&"
export * from "./tuijian.vue?vue&type=script&lang=js&"
import style0 from "./tuijian.vue?vue&type=style&index=0&id=aaef3cb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaef3cb8",
  null
  
)

export default component.exports